<template>
  <div class="box">
    <div
      class="hello-ezuikit-js"
      v-if="videoType=='1'"
      :style="{ width: width + 'px', position: 'relative' }"
    >
      <div :id="'video-container' + videoid" style="width: 100%; height: 100%">
        <div
          style="position: absolute; right: 5px; bottom: 5px"
          v-show="player"
        >
          <img
            src="../../assets/images/fullScreen.png"
            @click="fullScreen"
            alt=""
          />
        </div>
      </div>
      <div class="video-btn">
        <a v-show="videoPlayType == 1" @click="clickPlayback(2)">回放</a>
        <a v-show="videoPlayType == 2" @click="clickPlayback(1)">返回直播</a>
      </div>
      <div class="mubiao_close" @click="hideClose" v-if="showClose">
        <Icon type="md-close" />
      </div>
    </div>
    <div v-else-if="videoType=='5'">
      <iframe allowtransparency="yes" allowfullscreen="yes" width="100%" :height="height" v-if="hkUrl" :src="hkUrl" frameborder="0"></iframe>
    </div>
    <div v-else :style="'width:' + width + 'px'" style="margin: 0 auto">
      <video
        id="ico_video"
        class="video-js vjs-default-skin"
        controls
        preload="auto"
      >
        <source :src="httpUrl" type="application/x-mpegURL" />
      </video>
      <div class="mubiao_close" @click="hideClose" v-if="showClose">
        <Icon type="md-close" />
      </div>
    </div>
  </div>
</template>

<script>
import EZUIKit from "ezuikit-js";
//引入video.js
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  name: "playVideo",
  props: {
    httpUrl: String,
    width: {
      default: 700,
    },
    height: {
      default: 350,
    },
    showClose: {
      default: true,
    },
    videoid: {
      type: String,
      default: "1",
    },
    videoDeviceId: {
        default:""
    }
  },
  data() {
    return {
      player: null,
      videoType: "1",
      video_player: null,
      accessToken:
        "at.dyxftoagceifybie26ewtz516bmr0u3a-3k6l8jy0xn-1fzug2z-bpaeijxwy",
      themeData: {
        header: {
          color: "#1890ff",
          activeColor: "#FFFFFF",
          backgroundColor: "#000000",
          btnList: [
            {
              iconId: "deviceID",
              part: "left",
              defaultActive: 0,
              memo: "顶部设备序列号",
              isrender: 1,
            },
            {
              iconId: "deviceName",
              part: "left",
              defaultActive: 0,
              memo: "顶部设备名称",
              isrender: 1,
            },
            {
              iconId: "cloudRec",
              part: "right",
              defaultActive: 0,
              memo: "云存储",
              isrender: 0,
            },
            {
              iconId: "rec",
              part: "right",
              defaultActive: 0,
              memo: "SD卡回放",
              isrender: 0,
            },
          ],
        },
        footer: {
          color: "#FFFFFF",
          activeColor: "#1890FF",
          backgroundColor: "#00000021",
          btnList: [
            {
              iconId: "play",
              part: "left",
              defaultActive: 1,
              memo: "播放",
              isrender: 1,
            },
            {
              iconId: "capturePicture",
              part: "left",
              defaultActive: 0,
              memo: "截屏按钮",
              isrender: 1,
            },
            {
              iconId: "sound",
              part: "left",
              defaultActive: 0,
              memo: "声音按钮",
              isrender: 1,
            },
            {
              iconId: "pantile",
              part: "left",
              defaultActive: 0,
              memo: "云台控制按钮",
              isrender: 1,
            },
            {
              iconId: "recordvideo",
              part: "left",
              defaultActive: 0,
              memo: "录制按钮",
              isrender: 1,
            },
            {
              iconId: "talk",
              part: "left",
              defaultActive: 0,
              memo: "对讲按钮",
              isrender: 1,
            },
            {
              iconId: "zoom",
              part: "left",
              defaultActive: 0,
              memo: "电子放大",
              isrender: 1,
            },
            {
              iconId: "playback",
              part: "left",
              defaultActive: 1,
              memo: "回放按钮",
              isrender: 1,
            },
            {
              iconId: "hd",
              part: "right",
              defaultActive: 0,
              memo: "清晰度切换按钮",
              isrender: 1,
            },
            // {
            //   iconId: "webExpend",
            //   part: "right",
            //   defaultActive: 0,
            //   memo: "网页全屏按钮",
            //   isrender: 1,
            // },
            {
              iconId: "expend",
              part: "right",
              defaultActive: 0,
              memo: "全局全屏按钮",
              isrender: 1,
            },
          ],
        },
      },
      videoPlayType: 1,
      hkUrl: "",
    };
  },
  methods: {
    hideClose() {
      this.$emit("hideClose");
    },
    videoInit(str) {
      if (this.video_player) {
        this.video_player.src(this.httpUrl);
        this.video_player.play();
        return;
      }
      this.video_player = videojs(
        str,
        {
          src: this.httpUrl,
          autoplay: true,
        },
        function () {
          this.play();
        }
      );
    },
    //获取mp4视频地址
    getQlyVideoUrl() {
      return new Promise((resolve, reject) => {
          let dataObj = {
              type: "get",
              url: `/mcbw/cameras/qly/${this.videoDeviceId}`,
              obj: {
              
              },
          };
          this.$Axios(dataObj).then((res) => {
              if (res.data.success) {
                  resolve(res.data);
              }
          });
      });
    },
    getToken() {
      let _that = this;
      if(this.httpUrl == "mp4") {
        this.getQlyVideoUrl().then((res) => {
            if (res.success && res.data.includes("mp4")) {
              setTimeout(() => { 
                _that.hkUrl = res.data;
                _that.videoType = "5";
              }, 3000);
            }
        });
      } else if (this.httpUrl.includes("http")) {
        this.videoType = "3";
        this.$nextTick(() => {
          this.videoInit("ico_video");
        });
      } else {
        var data = {
          type: "get",
          url: `/mcbw/cameras/token`,
          obj: {},
        };
        this.$Axios(data).then((res) => {
          if (res.data.success) {
            this.accessToken = res.data.data;
            this.videoType = "1";
            this.player = new EZUIKit.EZUIKitPlayer({
              autoplay: true,
              id: "video-container" + this.videoid,
              accessToken: this.accessToken,
              url: this.httpUrl,
              // template: "security", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
              // 视频上方头部控件
              //header: ["capturePicture", "save", "zoom"], // 如果templete参数不为simple,该字段将被覆盖
              //plugin: ['talk'],                       // 加载插件，talk-对讲
              // 视频下方底部控件
              // footer: ["talk", "broadcast", "hd", "fullScreen"], // 如果template参数不为simple,该字段将被覆盖
              // audio: 1, // 是否默认开启声音 0 - 关闭 1 - 开启
              // openSoundCallBack: data => console.log("开启声音回调", data),
              // closeSoundCallBack: data => console.log("关闭声音回调", data),
              // startSaveCallBack: data => console.log("开始录像回调", data),
              // stopSaveCallBack: data => console.log("录像回调", data),
              // capturePictureCallBack: data => console.log("截图成功回调", data),
              // fullScreenCallBack: data => console.log("全屏回调", data),
              // getOSDTimeCallBack: data => console.log("获取OSDTime回调", data),
              width: this.width,
              height: this.height,
              plugin: ["talk"],
              themeData: this.themeData, //上面的对象内容
            });
          }
        });
      }
    },
    fullScreen() {
      this.player ? (this.player.opt.fullScreenStatus = 0) : "";
      this.player.fullScreen();
    },
    clickPlayback(videoType) {
      let _that = this;
      if (this.player) {
        // 销毁当前播放器实例
        this.player = null;
        setTimeout(() => {
          // 重新初始化播放器
          if (videoType == 1) {
            _that.player = new EZUIKit.EZUIKitPlayer({
              autoplay: true,
              id: "video-container" + this.videoid,
              accessToken: _that.accessToken,
              url: _that.httpUrl,
              width: _that.width,
              height: _that.height,
              plugin: ["talk"],
              themeData: this.themeData, //上面的对象内容
            });
          } else {
            _that.player = new EZUIKit.EZUIKitPlayer({
              autoplay: true,
              id: "video-container" + this.videoid,
              accessToken: _that.accessToken,
              url: _that.httpUrl,
              width: _that.width,
              height: _that.height,
              plugin: ["talk"],
              template: "pcRec", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
            });
          }
          _that.videoPlayType = videoType;
        }, 1000);
      }
    },
  },
  mounted() {
    this.hkUrl = this.previewUrl;
    this.getToken();
  },
  destroyed() {
    if (this.httpUrl.includes("ezopen")) {
      this.player = null;
    } else {
      this.video_player.dispose();
    }
  },
};
</script>
<style></style>
<style scoped lang="scss">
.box,
.box > div,
.hello-ezuikit-js {
  width: 100%;
  height: 100%;
}
.video-js,
video {
  width: 100%;
  height: 100%;
  min-height: 350px;
}
.video-js,
.vjs-fullscreen-control {
  outline: none;
}
.mubiao_close {
  position: absolute;
  right: 0;
  top: 0;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  overflow: hidden;
  background: none;
  cursor: pointer;
  z-index: 1;
  i {
    font-size: 20px;
  }
}
.video-btn {
  position: absolute;
  right: 55px;
  top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/videoPlay/videoPlays.vue